export default __webpack_public_path__ + "static/media/multi-and-dynamic-cake-banner-desktop.ab8d4184.jpg";